import { createFileRoute } from '@tanstack/react-router';
import { CrmArticlesPage } from '@pages/crm';

export const Route = createFileRoute('/$locale/_authenticated/crm/helpdesk/articles/new')({
  component: NewArticleRoute,
});
function NewArticleRoute() {
  const { locale } = Route.useParams();
  return <CrmArticlesPage locale={locale} search={Route.useSearch()} mode="create" />;
}
